import type { ReactNode } from 'react';
import { cn } from '@helpers/cn';
import { getPreviewFrameStyle, type PreviewSize } from './sizes';

interface PreviewStateFrameProps {
  size: PreviewSize;
  /** Fill a responsive grid cell while retaining the aspect ratio. */
  fluid?: boolean;
  /** Draw the frame border. Turn off when the child renders its own. */
  bordered?: boolean;
  children: ReactNode;
}

/**
 * A fixed-footprint frame for a preview's loading and error states, so the
 * placeholder occupies exactly the same space the eventual thumbnail will.
 * Keeps the framed loader/fallback markup out of every preview component.
 */
const PreviewStateFrame = ({
  size,
  fluid,
  bordered = true,
  children,
}: PreviewStateFrameProps) => (
  <div
    className={cn(
      'eye:flex eye:items-center eye:justify-center eye:overflow-hidden eye:rounded-md',
      bordered && 'eye:border eye:border-grey-100',
    )}
    style={getPreviewFrameStyle(size, fluid)}
  >
    {children}
  </div>
);

export default PreviewStateFrame;
